@import '../../../../../../constants/spacing.module.less';
@import (reference) 'ui-components/components/text/text.module.less';

.address {
  width: 100%;
  gap: @space-8;
}

.read-only-address {
  .paragraph();
  color: var(--default--text-color--17);
}

.address-label-actions {
  padding-left: @space-8;

  display: inline-flex;
  align-items: center;
  gap: @space-4;
}
